import React, { useState, useEffect } from "react";
import axios from "axios";

const Education = () => {
  const [educations, setEducations] = useState([]); // Ensure the initial state is an array
  const [isContentVisible, setIsContentVisible] = useState(true);
  const [isEditing, setIsEditing] = useState(false);

  const fetchEducations = async () => {
    try {
      const response = await axios.get("http://127.0.0.1:8000/dashboard/education/");
      const data = response.data.results || [];
      if (Array.isArray(data)) {
        setEducations(data);
      } else {
        console.error("API response does not contain a valid array:", response.data);
        setEducations([]);
      }
    } catch (error) {
      console.error("Error fetching education data:", error);
    }
  };
  
  
  useEffect(() => {
    fetchEducations();
  }, []);

  const handleInputChange = (index, field, value) => {
    const updatedEducations = [...educations];
    updatedEducations[index][field] = value;
    setEducations(updatedEducations);
  };

  const addEducation = () => {
    setEducations([
      ...educations,
      {
        institution: "",
        degree: "",
        field_of_study: "",
        start_date: "",
        end_date: "",
        cgpa: "",
      },
    ]);
  };

  const saveEducations = async () => {
    try {
      await Promise.all(
        educations.map(async (edu) => {
          if (!edu.id) {
            // Create new education
            await axios.post("http://127.0.0.1:8000/dashboard/education/create/", edu);
          } else {
            // Update existing education
            await axios.put(
              `http://127.0.0.1:8000/dashboard/education/update/${edu.id}/`,
              edu
            );
          }
        })
      );
      setIsEditing(false);
      fetchEducations();
    } catch (error) {
      console.error("Error saving education data:", error);
    }
  };

  const deleteEducation = async (id) => {
    try {
      if (id) {
        await axios.delete(`http://127.0.0.1:8000/dashboard/education/destroy/${id}/`);
        fetchEducations();
      } else {
        setEducations(educations.filter((edu) => edu.id !== id));
      }
    } catch (error) {
      console.error("Error deleting education:", error);
    }
  };

  return (
    <div className="flex flex-col w-full mr-11 bg-white rounded-3xl mt-4 h-full">
      <div className="flex justify-between items-center">
        <h1 className="font-bold text-xl m-3 ml-9 mt-4">Education</h1>
        <button
          className="m-3 mr-7 text-[#0077af] text-xl focus:outline-none"
          onClick={() => setIsContentVisible(!isContentVisible)}
        >
          {isContentVisible ? "\u25B2" : "\u25BC"}
        </button>
      </div>

      {isContentVisible && (
        <div className="m-10 mt-4 space-y-6">
          {Array.isArray(educations) &&
            educations.map((edu, index) => (
              <div
                key={edu.id || index}
                className="p-6 border border-gray-300 rounded-lg shadow-sm bg-gray-50"
              >
                <div className="grid grid-cols-3 gap-6">
                  {[
                    "institution",
                    "degree",
                    "field_of_study",
                    "start_date",
                    "end_date",
                    "cgpa",
                  ].map((field) => (
                    <legend className="text-gray-500" key={field}>
                      {field.replace("_", " ").toUpperCase()} <br />
                      {isEditing ? (
                        <input
                          type="text"
                          value={edu[field] || ""}
                          onChange={(e) =>
                            handleInputChange(index, field, e.target.value)
                          }
                          className="border rounded p-2 w-full"
                        />
                      ) : (
                        <span className="text-black font-semibold">
                          {edu[field] || "Not Provided"}
                        </span>
                      )}
                    </legend>
                  ))}
                  {isEditing && edu.id && (
                    <button
                      onClick={() => deleteEducation(edu.id)}
                      className="text-red-600 hover:text-red-800 flex text-lg mt-0"
                    >
                      🗑️
                    </button>
                  )}
                </div>
              </div>
            ))}
          <div className="flex justify-between items-center">
            <button
              onClick={addEducation}
              className="bg-[#0077af] text-white px-4 py-2 rounded hover:bg-[#005f80]"
            >
              Add Education
            </button>
            {isEditing && (
              <>
                <button
                  onClick={saveEducations}
                  className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 mx-2"
                >
                  Save
                </button>
                <button
                  onClick={() => setIsEditing(false)}
                  className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 mx-2"
                >
                  Cancel
                </button>
              </>
            )}
            {!isEditing && (
              <button
                onClick={() => setIsEditing(true)}
                className="bg-[#0077af] text-white px-4 py-2 rounded hover:bg-white hover:text-[#0077af] hover:border-2 hover:border-[#0077af]"
              >
                Edit
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Education;
